export default "/images/vendor/flag-icons/flags/1x1/bm.svg?4a80f894c485745e46a2547b6acb1c72";